import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const SendIcon = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 28}
        height={size ?? 28}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.63297 7.37333L18.538 4.07166C22.983 2.59 25.398 5.01666 23.928 9.46166L20.6263 19.3667C18.4096 26.0283 14.7696 26.0283 12.553 19.3667L11.573 16.4267L8.63297 15.4467C1.9713 13.23 1.9713 9.60166 8.63297 7.37333Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.7949 15.925L15.9716 11.7367"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default SendIcon;
